"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryGraph = exports.postForm = exports.fetchPipe = exports.fetchBuffer = exports.fetchJson = exports.Fetcher = void 0;

var ms_1 = __importDefault(require("ms"));

var abort_controller_1 = __importDefault(require("abort-controller"));

var Helper_1 = require("./Helper");

var cross_fetch_1 = __importDefault(require("cross-fetch"));

var FetcherConfiguration_1 = require("./FetcherConfiguration");

var Fetcher = /*#__PURE__*/function () {
  function Fetcher(customDefaults) {
    _classCallCheck(this, Fetcher);

    this.customDefaults = customDefaults !== null && customDefaults !== void 0 ? customDefaults : {};
  }

  _createClass(Fetcher, [{
    key: "overrideDefaults",
    value: function overrideDefaults(_overrideDefaults) {
      this.customDefaults = (0, Helper_1.mergeRequestOptions)(this.customDefaults, _overrideDefaults);
    }
  }, {
    key: "fetch",
    value: function fetch(url, options) {
      return fetchInternal(url, _objectSpread({
        method: 'get',
        // it is better to not assume how this generic fetch will be used, not sending retries
        attempts: 1,
        // no timeout by default
        timeout: '0s',
        // no wait-time by default
        waitTime: '0s'
      }, (0, Helper_1.mergeRequestOptions)(this.customDefaults, options)));
    }
    /**
     * @deprecated please use Fetcher.fetch instead
     */

  }, {
    key: "fetchJson",
    value: function fetchJson(url, options) {
      return _fetchJson(url, (0, Helper_1.mergeRequestOptions)(this.customDefaults, options));
    }
    /**
     * @deprecated please use Fetcher.fetch instead
     */

  }, {
    key: "fetchBuffer",
    value: function fetchBuffer(url, options) {
      return _fetchBuffer(url, (0, Helper_1.mergeRequestOptions)(this.customDefaults, options));
    }
    /**
     * Fetches the url and pipes the response obtained from the upstream to the `writeTo` Stream and
     * returns the headers from the upstream request.
     * IMPORTANT: THIS METHOD DOES NOT AWAIT THE PIPE TO FINISH. THE PROMISE FULFILLS RIGHT AFTER WE RECEIVE THE HEADERS.
     * @param url to request
     * @param writeTo the stream to pipe the response to
     * @param options config for the request
     * @deprecated please use Fetcher.fetch instead
     */

  }, {
    key: "fetchPipe",
    value: function fetchPipe(url, writeTo, options) {
      return _fetchPipe(url, writeTo, (0, Helper_1.mergeRequestOptions)(this.customDefaults, options));
    }
    /**
     * @deprecated please use Fetcher.fetch instead
     */

  }, {
    key: "postForm",
    value: function postForm(url, options) {
      return _postForm(url, (0, Helper_1.mergeRequestOptions)(this.customDefaults, options));
    }
  }, {
    key: "queryGraph",
    value: function queryGraph(url, query, variables, options) {
      return _queryGraph(url, query, variables, (0, Helper_1.mergeRequestOptions)(this.customDefaults, options));
    } // Clones the fetcher and creates a new one

  }, {
    key: "clone",
    value: function clone() {
      return new Fetcher(this.customDefaults);
    }
  }]);

  return Fetcher;
}();

exports.Fetcher = Fetcher;

function _fetchJson(_x, _x2) {
  return _fetchJson2.apply(this, arguments);
}

function _fetchJson2() {
  _fetchJson2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchInternal(url, (0, Helper_1.mergeRequestOptions)(FetcherConfiguration_1.FETCH_JSON_DEFAULTS, options));

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.json());

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchJson2.apply(this, arguments);
}

exports.fetchJson = _fetchJson;

function _fetchBuffer(_x3, _x4) {
  return _fetchBuffer2.apply(this, arguments);
}

function _fetchBuffer2() {
  _fetchBuffer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchInternal(url, (0, Helper_1.mergeRequestOptions)(FetcherConfiguration_1.FETCH_BUFFER_DEFAULTS, options));

          case 2:
            response = _context2.sent;
            _context2.t0 = Buffer;
            _context2.next = 6;
            return response.arrayBuffer();

          case 6:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", _context2.t0.from.call(_context2.t0, _context2.t1));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchBuffer2.apply(this, arguments);
}

exports.fetchBuffer = _fetchBuffer;
/**
 * Fetches the url and pipes the response obtained from the upstream to the `writeTo` Stream and
 * returns the headers from the upstream request.
 * IMPORTANT: THIS METHOD DOES NOT AWAIT THE PIPE TO FINISH. THE PROMISE FULFILLS RIGHT AFTER WE RECEIVE THE HEADERS.
 * @param url to request
 * @param writeTo the stream to pipe the response to
 * @param options config for the request
 */

function _fetchPipe(_x5, _x6, _x7) {
  return _fetchPipe2.apply(this, arguments);
}

function _fetchPipe2() {
  _fetchPipe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, writeTo, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchInternal(url, (0, Helper_1.mergeRequestOptions)(FetcherConfiguration_1.FETCH_BUFFER_DEFAULTS, options));

          case 2:
            response = _context3.sent;

            if (response.body) {
              _context3.next = 5;
              break;
            }

            throw new Error('The function fetchPipe only works in Node.js compatible enviroments');

          case 5:
            if (!('pipe' in response.body)) {
              _context3.next = 9;
              break;
            }

            ;
            response.body.pipe(writeTo);
            return _context3.abrupt("return", response.headers);

          case 9:
            throw new Error('The function fetchPipe only works in Node.js compatible enviroments');

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchPipe2.apply(this, arguments);
}

exports.fetchPipe = _fetchPipe;

function _postForm(_x8, _x9) {
  return _postForm2.apply(this, arguments);
}

function _postForm2() {
  _postForm2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, options) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchInternal(url, (0, Helper_1.mergeRequestOptions)(FetcherConfiguration_1.POST_DEFAULTS, options));

          case 2:
            res = _context4.sent;
            return _context4.abrupt("return", res.json());

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _postForm2.apply(this, arguments);
}

exports.postForm = _postForm;

function _queryGraph(_x10, _x11, _x12, _x13) {
  return _queryGraph2.apply(this, arguments);
}

function _queryGraph2() {
  _queryGraph2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, query, variables, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _postForm(url, _objectSpread({
              body: JSON.stringify({
                query: query,
                variables: variables
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }, options));

          case 2:
            response = _context5.sent;

            if (!response.errors) {
              _context5.next = 5;
              break;
            }

            throw new Error("Error querying graph. Reasons: ".concat(JSON.stringify(response.errors)));

          case 5:
            return _context5.abrupt("return", response.data);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _queryGraph2.apply(this, arguments);
}

exports.queryGraph = _queryGraph;

function identity(_x14) {
  return _identity.apply(this, arguments);
}
/**
 * This is the method where everything happens, all of the methods in this file call internally fetchInternal.
 * If you need to modify something for all requests, do it here.
 */


function _identity() {
  _identity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(a) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", a);

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _identity.apply(this, arguments);
}

function fetchInternal(_x15, _x16) {
  return _fetchInternal.apply(this, arguments);
}

function _fetchInternal() {
  _fetchInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url, options) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", (0, Helper_1.retry)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var controller, transformRequest, transformResponse, request, timeoutTime, timeout, response, responseText;
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      controller = new abort_controller_1.default();
                      transformRequest = options.requestMiddleware || identity;
                      transformResponse = options.responseMiddleware || identity;
                      _context7.next = 5;
                      return transformRequest({
                        requestInfo: url,
                        requestInit: {
                          signal: controller.signal,
                          body: options.body,
                          method: options.method,
                          headers: (0, FetcherConfiguration_1.getAllHeaders)(options)
                        }
                      });

                    case 5:
                      request = _context7.sent;
                      // schedule timeout right after transforming Request
                      timeoutTime = (0, ms_1.default)(options.timeout);
                      timeout = timeoutTime ? setTimeout(function () {
                        controller.abort();
                      }, timeoutTime) : 0;
                      _context7.prev = 8;
                      _context7.next = 11;
                      return (0, cross_fetch_1.default)(request.requestInfo, request.requestInit);

                    case 11:
                      response = _context7.sent;

                      if (!response.ok) {
                        _context7.next = 18;
                        break;
                      }

                      _context7.next = 15;
                      return transformResponse(response);

                    case 15:
                      return _context7.abrupt("return", _context7.sent);

                    case 18:
                      _context7.next = 20;
                      return response.text();

                    case 20:
                      responseText = _context7.sent;
                      throw new Error("Failed to fetch ".concat(url, ". Got status ").concat(response.status, ". Response was '").concat(responseText, "'"));

                    case 22:
                      _context7.prev = 22;
                      if (timeout) clearTimeout(timeout);
                      return _context7.finish(22);

                    case 25:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7, null, [[8,, 22, 25]]);
            })), options.attempts, options.waitTime));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchInternal.apply(this, arguments);
}